import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft, FiPlus, FiTruck, FiCheckCircle, FiAlertCircle, FiClock } from 'react-icons/fi';
import DatePicker from '../../../../components/DatePicker';
import { useDelivery } from '../context/DeliveryContext';

export default function DeliveryManagementHeader() {
  const navigate = useNavigate();
  const { selectedDate, setSelectedDate, stats, newDelivery, loading } = useDelivery();
  const cards = [
    { title: 'Deliveries', value: stats.total, Icon: FiTruck, color: 'text-blue-600 bg-blue-50' },
    { title: 'Submitted Checks', value: stats.submitted, Icon: FiCheckCircle, color: 'text-green-600 bg-green-50' },
    { title: 'Issues / Rejected', value: stats.issues, Icon: FiAlertCircle, color: 'text-red-600 bg-red-50' },
    { title: 'Pending Checks', value: stats.pending, Icon: FiClock, color: 'text-indigo-600 bg-indigo-50' },
  ];
  return <div>
    <div className="flex flex-wrap items-center justify-between gap-3">
      <button onClick={() => navigate('/checks')} className="flex items-center gap-1 text-sm font-semibold text-indigo-600"><FiChevronLeft /> Checks</button>
      <DatePicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
    </div>
    <div className="mt-4 flex flex-wrap items-start justify-between gap-4">
      <div className="flex items-start gap-5">
        <div className="flex h-16 w-16 items-center justify-center rounded-xl bg-blue-600 text-white"><FiTruck className="h-8 w-8" /></div>
        <div><h1 className="text-3xl font-bold text-slate-900">Delivery Management</h1><p className="mt-1 text-sm text-slate-600">Record incoming goods and complete a separate check for each delivery.</p></div>
      </div>
      <button onClick={newDelivery} className="flex items-center gap-2 rounded-lg bg-indigo-600 px-6 py-3 text-sm font-semibold text-white"><FiPlus /> New Delivery</button>
    </div>
    <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {cards.map(({ title, value, Icon, color }) => <div key={title} className="flex items-center gap-4 rounded-xl border border-slate-200 bg-white px-5 py-5 shadow-sm">
        <div className={`flex h-14 w-14 items-center justify-center rounded-full ${color}`}><Icon className="h-7 w-7" /></div>
        <div><p className="text-sm font-semibold text-slate-800">{title}</p><p className="text-3xl font-bold text-slate-900">{loading ? '—' : value}</p><p className="text-xs text-slate-500">For the selected date</p></div>
      </div>)}
    </div>
  </div>;
}
